<div class="container-fluid">
    <div class="row   justify-content-start mb-2">
        <div class="col-12">
            <span class="iso-header ml-2">
                {{ 'bikeshop.shop_setup.card_headers.service_indicators' | translate }}
            </span>
            <div class="pull-right">
                <div>
                  <button pButton (click)="addServiceIndicator()" class="p-button-raised" [disabled]="loadingConfig"
                    label="{{'bikeshop.rentals.service_indicators_config.configuration_add_service_indicator' | translate}}"
                    style="width: 230px;"></button>
                </div>
              </div>
        </div>
    </div>

    <div class="no-configured-service-indicators" *ngIf="!serviceIndicatorConfigs?.length && !loadingConfig">
        {{ 'bikeshop.rentals.service_indicators_config.no_configured_service_indicators' | translate }}
    </div>

    <div class="service-indicator-container">
        <div *ngFor="let serviceIndicator of serviceIndicatorConfigs" (click)="updateServiceIndicator(serviceIndicator)">
            <div class="header">{{serviceIndicator.serviceIndicatorName}}</div>
            <div class="row">
                <div class="col-md-7 label">{{'bikeshop.rentals.service_indicators_config.service_indicator_status' |
                    translate}}:</div>
                <div class="col-md-5 label bold right-align"
                    [ngClass]="{'red': !serviceIndicator.isActive, 'green': serviceIndicator.isActive}">{{
                    serviceIndicator.isActive ? 'Active' : 'InActive'}}</div>
            </div>
            <div class="row">
                <div class="col-md-7 label">{{'bikeshop.rentals.service_indicators_config.configuration_mode' | translate}}:</div>
                <div class="col-md-5 label bold right-align">{{(serviceIndicator.mode === 'basic' ? 'bikeshop.rentals.service_indicators_config.configuration_mode_basic' : 'bikeshop.rentals.service_indicators_config.configuration_mode_advanced') | translate}}</div>
            </div>

            <div class="row margin-top-16" *ngIf="serviceIndicator.linkedCategoryNames?.length > 0">
                <div class="col-md-7 label">{{'bikeshop.rentals.service_indicators_config.linked_product_categories' | translate}}:</div>
                <div class="col-md-5 label right-align">
                    <div *ngFor="let category of serviceIndicator.linkedCategoryNames; let i = index">
                        {{category.categoryName}}
                    </div>
                </div>
            </div>

        </div>
    </div>

</div>


<p-sidebar #NavSideBar [(visible)]="showServiceIndicatorConfig" position="right" [autoZIndex]="false"
    [style]="{width:'750px', background: '#FAFAFA', 'overflow-x': 'auto','z-index': '1001'}"
    (onHide)="NavSideBar.destroyModal();showServiceIndicatorConfig = false;getServiceIndicatorConfig()">
    <div *ngIf="showServiceIndicatorConfig">
        <app-rental-service-indicator-config-sidebar 
            [serviceIndicatorConfig]="selectedServiceIndicator"
            [metricOptions]="metricOptions" 
            [serviceIndicatorModes]="serviceIndicatorModes"
            [rentalConfig]="rentalConfig" 
            (onClose)="closeSidebar()">

        </app-rental-service-indicator-config-sidebar>
    </div>
</p-sidebar>